module.exports = __webpack_public_path__ + "img/icon-contact.b95a7f83.svg";